import React, { useState, useMemo } from 'react';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import EditionTable from './Table';
import { getPlatformName } from '../../_config/utils';
import Visualis from './Visualis';
import useRPDLineCharts from '@/pages/intelligence/pages/TopCharts/MobileGames/hooks/useRPDLineCharts';
import { useIntl } from 'umi';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import { getMetricTitle } from '@/pages/intelligence/utils/common';

const EditionsShareCard = (props: any) => {
  const {
    loading,
    tableData = [],
    tableTotal = 0,
    pageId,
    dataSource,
    isDropdown,
    showRankSwitch,
    entityType,
    dateType,
    startDate,
    endDate,
    chartType,
    setChartType,
    editionTableList,
    basicInfo,
    editionLineList,
    lineData,
    cardStatus,
    fixedTableData,
    pageSortAttr,
    onTableSortChage,
    chartSegment,
    firstWeekSinceReleaseDates = [],
    ...rest
  } = props;

  // console.log('EditionsShareCard',props);

  const { formatMessage } = useIntl(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};

  const blockData = useMemo(() => {
    // 说明：edition没有total展示，仅展示前5个游戏
    // let source = tableData?.length ? JSON.parse(JSON.stringify(tableData))?.filter((v: any) => !['', 'total']?.includes(v?.app_id)) : [];
    let listTemp = tableData?.map((v: any, index: number) => {
      // console.log('vvvvvv', v);
      const metricsData = (Array.isArray(v?.metrics) && v?.metrics?.length > 0) ? v?.metrics.find((item: any) => item.metric == chartSegment) : {};
      let valueTemp = metricsData?.value || 0;
      return {
        app_id: v?.app_id || '',
        name: v?.name + '(' + getPlatformName(v?.platform) + ')',
        cover: v?.cover || '',
        value: valueTemp,
      }
    });

    // 对Sum Revenue按初始降序排序
    const dataList = JSON.parse(JSON.stringify(listTemp)).sort((a: any, b: any) => b.value - a.value);

    return dataList?.slice(0, 5);
  }, [tableData]);

  const chartLineData = useMemo(() => {
    if (!firstWeekSinceReleaseDates.length) {
      return lineData;
    }

    return {
      ...lineData,
      source: lineData?.source?.map((item: any) => {
        const historyMap = new Map(
          item?.history?.map((historyItem: any) => [historyItem?.time, historyItem]),
        );
        return {
          ...item,
          history: firstWeekSinceReleaseDates.map((date: string) => {
            return historyMap.get(date) || { time: date, value: null };
          }),
        };
      }) || [],
    };
  }, [lineData, firstWeekSinceReleaseDates]);

  // 折线图相关hooks
  const {
    seriesData: lineSeriesData,
    xAxisData: lineXAxisData,
    yAxisFormatter: lineYAxisFormatter,
    lineLegendsCustomMade,
  } = useRPDLineCharts('source', chartLineData, dateType);

  return (
    <div className="dbi-editionsshare-card">
      {isLoading || isNoData || isError || isDropdown ? (
        <CardSlotV2
          className="dbi-mobileGames-card-context"
          title={formatMessage({ id: `dbi_detail_editions_share` })}
          iconList={[]}
        >
          <CardStats cardStatus={cardStatus} isDropdown={isDropdown} />
        </CardSlotV2>
      ) : (
        <CardSlotV2
          className="dbi-mobileGames-card-context"
          title={formatMessage({ id: `dbi_detail_editions_share` })}
          activeTab={chartType}
          getChange={(value: any) => {
            setChartType(value);
          }}
        >
          <div className="editionsshare-card-line">
            <Visualis
              barOrPieData={blockData}
              middleTitle={basicInfo?.name}
              chartType={chartType}
              dataSource={dataSource}
              // isPolishing={isPolishing} //是否有补齐数据
              lineData={lineData} //折线数据，已经处理了交互，可直接展示
              lineSeriesData={lineSeriesData}
              lineXAxisData={lineXAxisData}
              lineLegendsCustomMade={lineLegendsCustomMade}
              yAxisFormatter={lineYAxisFormatter}
              dateType={dateType}
              pageId={pageId}
              startDate={startDate}
              endDate={endDate}
              getMetricTitle={getMetricTitle}
            />
          </div>

          <EditionTable
            tableData={tableData}
            pageId={pageId}
            dataSource={dataSource}
            showRankSwitch={showRankSwitch} //展示Rank列
            entityType={entityType}
            gameName={basicInfo?.name}
            gameCover={basicInfo?.cover}
            dateType={dateType}
            startDate={startDate}
            endDate={endDate}
            // chartSegment={chartSegment}
            fixedTableData={fixedTableData}
            pageSortAttr={pageSortAttr}
            onTableSortChage={onTableSortChage}
            {...rest}
          />
        </CardSlotV2>
      )}
    </div>
  );
};

export default EditionsShareCard;
